import { StatusAtendimentoColeta } from "src/app/coleta/atendimento-coleta/status-atendimento-coleta.enum";
import { StatusAtendimento } from "src/app/homecare/atendimento/atendimento.enum";
import { AvaliacaoSumarioPacienteDTO } from "src/app/homecare/paciente/components/sumario-paciente/components/sumario-paciente-quadro-historico-atendimento/components/sumario-paciente-historico-avaliacao-item/dto/avaliacao-sumario-paciente-dto.interface";
import { StatusEvento } from "src/app/homecare/paciente/components/sumario-paciente/components/sumario-paciente-quadro-historico-atendimento/components/sumario-paciente-historico-avaliacao-item/model/status-evento.enum";
import { StatusAtendimentoSala } from "src/app/sala-de-medicacao/atendimento/model/status-atendimento-sala.model";

export class AssinaturaDigitalUtil {

  /**
   * Este método tambem e utilizado em listagem fora da lista-component (no sumario do paciente)
   */
  public static getAssinaturaDigitalHtml(data: AvaliacaoSumarioPacienteDTO, exibirIconeDefault: boolean): string {
    if ( data.tipo === 'AGENDAMENTO' || data.tipo === 'COLETA' ) {
      return '';
    }
    if (!(data.statusAtendimento === StatusAtendimento.REALIZADO
          || data.statusAtendimento === StatusAtendimentoColeta.REALIZADO
          || data.statusAtendimento === StatusAtendimentoColeta.FINALIZADO
          || data.statusAtendimento === StatusAtendimentoSala.REALIZADO)) {
      return '';
    }

    const htmlDefault = exibirIconeDefault ? '<i class="material-icons texto-cinza" title="Sem assinatura digital">fingerprint</i>' : '<i class="material-icons texto-cinza-super-claro cursor-default" title="Sem assinatura digital">fingerprint</i>';
    if ( !data.assinaturaDigitalStatusEvento ) {
      return htmlDefault;
    }

    switch ( StatusEvento[data.assinaturaDigitalStatusEvento] ) {
      case StatusEvento.INICIADO:
        return '<i title="Assinatura digital pendente" class="material-icons warning">fingerprint</i>';

      case StatusEvento.FALHA:
        return '<i title="Assinatura digital finalizada com falha" class="material-icons danger">fingerprint</i>';

      case StatusEvento.SUCESSO:
        return '<i title="Assinatura digital finalizada com sucesso" class="material-icons success cursor-default">fingerprint</i>';

      default:
        return htmlDefault;
    }
  }

  public static extrairPdfDoJsonAssinadoPelaEVAL(response: string): string {
    try {
      const json = JSON.parse(response);
      const pdfBase64 = json['documents'][0]['signatures'][0]['value'];

      return pdfBase64
    }
    catch(e) {
     throw e;
    }
  }
}
